import { getTranslatedText } from "../../../../utils/getTranslatedText";
import { useGetTranslatedText } from "../../lms/queries";
import styles from "./styles.module.scss";

const ScoreProgress = ({ score = 0 }) => {
  const languageId = localStorage.getItem("l_id") || 1;
    
  const { data: translatedTextResponse } = useGetTranslatedText(languageId);
    
  const { data: translatedText = [] } = translatedTextResponse || {};

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.label}>
          {
              getTranslatedText(
                translatedText,
                "your_score",
                "Your Score",
            )}
          </span>
        <span className={styles.value}>{score}</span>
      </div>

      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${score}` }}
        />
      </div>
    </div>
  );
};

export default ScoreProgress;